// extracted by mini-css-extract-plugin
export default {"divider":"DividerComponent_divider__pZSmf"};